// extracted by extract-css-chunks-webpack-plugin
module.exports = {"entry_gray":"entry_gray_3u7lN","entry_wrap":"entry_wrap_3AcL6"};